import { LoaderContainer } from '../../../Loader';
import * as React from 'react';

import { PublicationLayout } from '../PublicationLayout/PublicationLayout';

export const PublishTermsLoading = () => {
  return <PublicationLayout content={<LoaderContainer />} />;
};
